import { render, staticRenderFns } from "./Profesionales.vue?vue&type=template&id=48825e77&scoped=true"
import script from "./Profesionales.vue?vue&type=script&lang=js"
export * from "./Profesionales.vue?vue&type=script&lang=js"
import style0 from "./Profesionales.vue?vue&type=style&index=0&id=48825e77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48825e77",
  null
  
)

export default component.exports